import { getIcon, LinkSearchResultCard } from '@monash/portal-frontend-common';
import { getPrimaryUrl } from './utils';
import { resolveCategoryNames } from './resolve-category-names';

export const LinkTileAdapter = ({ entity, allCategories, className }) => {
  const { linkType, name, description, icon, categories } = entity ?? {};

  return (
    <LinkSearchResultCard
      linkType={linkType}
      name={name}
      description={description}
      icon={getIcon(icon)}
      categoryNames={resolveCategoryNames(categories, allCategories)}
      url={getPrimaryUrl(entity)}
      className={className}
    />
  );
};
